import { MentoringDataType } from "@/types/mentoring"
import { normalizeCalLink } from "@/utils/calendarize"
import CalendarizeEmbed from "./CalendarizeEmbed"

export default function RescheduleMentoringModal({
  mentoring,
  onSuccess,
}: {
  mentoring: MentoringDataType
  onSuccess?: () => void
}) {
  return (
    <CalendarizeEmbed
      calLink={normalizeCalLink(mentoring.reagendamentoUrl)}
      onSuccess={onSuccess}
      emptyMessage="Link de reagendamento não disponível para esta mentoria."
    />
  )
}
